<template>

  <v-container fluid grid-list-xl>

    <H2 class="ma=3">Customer Code : {{this.$store.getters.get_user_code }}  {{this.$store.getters.get_user_name }}  </H2>
    <v-divider></v-divider>

        <v-container fluid grid-list-xl>
            <v-layout row wrap>     
                <v-flex d-flex >
                    <div>
                        <center><H3>Customer log</H3></center>

                        <v-toolbar-title>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-toolbar-title>

                        <v-data-table
                            class="table"
                            :headers="order_headers"
                            :items="order_t"
                            :search="search"
                            :rows-per-page-items="[10, 25]">
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.date_create }}</td>
                                <td class="text-xs-left">{{ props.item.tran_idi }}</td>
                                <td class="text-xs-left">{{ props.item.event }}</td>
                            </template>
                        </v-data-table>

                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </v-container>

</template>

<script>
export default {
  data() {
    return {
            order_headers:[ 
              { text: 'Date ceate ', value: 'date_create' },
              { text: 'id', value: 'tran_idi' },
              { text: 'Description', value: 'event' },
            ],
            credit_t: [],
            order_t: [],
            search: '',

    }
  },
    created () {
      console.log("CREATE")
      this.read_data()
  }, 
  methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_customer_log_details.php',{
                        params: {
                            scode: this.$store.getters.get_user_code ,
                            sdate: this.$store.getters.get_date ,
                        }
                    }).then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.order_t = result
            console.log(vm.order_t)
            });
        },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customer_log_details.vue